<template>
  <b-modal id="view_file_modal" ref="view_file_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text" v-if="notEmptyObject(file)">
        <h1 v-if="$store.state.files.type === 'company'">
          <i class="far fa-file"></i>
          <span v-if="file.file_type !== null">{{ file.file_type.file_type }}</span> File Uploaded
        </h1>
        <h1 v-if="$store.state.files.type === 'order_job'">
          <i class="far fa-file"></i>
          <span v-if="file.file_type !== null">{{ file.file_type.file_type }}</span> File Uploaded
        </h1>
        <h1 v-else-if="$store.state.files.type === 'worker'">
          <i class="far fa-file"></i>
          <span v-if="file.file_type !== null">{{ file.file_type.file_type }}</span> File Uploaded
        </h1>

        <p id="mh-info" v-if="notEmptyObject(file)">
          Uploaded by
          <span v-if="file.file_log_by !== null && file.file_logs !== null && file.file_logs.log_by_type === 'App\\Models\\Users\\User'">
            {{ file.file_log_by.first_name }} {{ file.file_log_by.surname }}
          </span>
          <span v-else-if="file.file_log_by !== null && file.file_logs !== null && file.file_logs.log_by_type === 'App\\Models\\Workers\\Worker'">
            Worker
          </span>
          on {{ file.updated_at | formatDateTime }}
        </p>

      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"
              v-if="!missing_settlement_indefinite && !missing_settlement_expiry && !missing_visa_indefinite && !missing_visa_expiry && !old_id_type"
      ><i class="fas fa-times"></i></button>
    </div>

    <div class="row mb-3" style="background: #ebebeb;"
         v-if="missing_document_expiry_date || missing_settlement_indefinite || missing_settlement_expiry || missing_visa_indefinite || missing_visa_expiry || old_id_type">
      <div class="col-12">
        <ValidationObserver ref="viewUpdateFileForm" slim>
          <form role="form" @submit.prevent="update_file()" class="row">
            <!-- if pe insurance cert OR pi insurance cert OR if pe & pi insurance cert OR if passport OR if drivers licence OR if biometric ID -->
            <div v-if="old_id_type" class="col-12">
              <div class="row">
                <div class="col-12">
                  <h4 class="red_color mt-2 mb-0">OLD ID TYPE</h4>
                  <p><em>Please correctly categorise the Identification file uploaded.</em></p>
                </div>
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="File Type" tag="div" class="form-group col-11 offset-1">
                  <label class="form-label" for="file_type">File Type</label>
                  <multiselect v-model="file.file_type" id="file_type" name="file_type" placeholder="" :allow-empty="false" :selectLabel="''" class="requiredField"
                               :options="file_types" label="file_type" :show-labels="false" @input="file_type_select(file.file_type, file)" @open="clearType"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <div v-if="missing_document_expiry_date && (file.file_type !== null && (file.file_type.id === 10 || file.file_type.id === 11 || file.file_type.id === 19 ||
            file.file_type.id === 20 || file.file_type.id === 25 || file.file_type.id === 26 || file.file_type.id === 27 || file.file_type.id === 29 || file.file_type.id === 30 ||
            file.file_type.id === 31))" class="col-12">
              <div class="row">
                <div class="col-12">
                  <h4 class="red_color mt-2 mb-0">MISSING EXPIRY DATE</h4>
                  <p><em>Please add an expiry date for the uploaded Identification file.</em></p>
                </div>
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Document Expiry Date" tag="div" class="form-group col-11 offset-1">
                  <label class="form-label" for="document_expiry_date">Document Expiry Date</label>
                  <datepicker v-model="file.document_expiry_date" id="document_expiry_date" name="document_expiry_date" :input-class="['date-input', 'requiredField', classes]"
                              :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                              @input="select_document_expiry(file.document_expiry_date, file)" :use-utc="true"></datepicker>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <!-- if settlement status doc -->
            <div v-if="missing_settlement_indefinite || missing_settlement_expiry" class="col-12">
              <div class="row">
                <div class="col-12">
                  <h4 class="red_color mt-2">Incomplete Settlement Status information</h4>
                </div>
                <div class="col-12">
                  <div class="row">
                    <label class="col-7 cardLabel" style="line-height: 19px" for="settlement_indefinite">Indefinite Settlement?</label>
                    <div class="col-5 form-group">
                      <bootstrap-toggle v-model="file.settlement_indefinite" id="settlement_indefinite" name="settlement_indefinite" :options="{ on:
                      'Yes', off: 'No' }"/>
                    </div>
                  </div>
                </div>
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Settlement Expiry Date" tag="div" class="col-12 form-group"
                                    v-if="!file.settlement_indefinite">
                  <label class="form-label" for="settlement_expiry">Settlement Expiry Date</label>
                  <datepicker v-model="file.settlement_expiry" id="settlement_expiry" name="settlement_expiry" :input-class="['date-input', 'requiredField', classes]"
                              :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                              @input="select_settlement_expiry(file.settlement_expiry, file)" :use-utc="true"></datepicker>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <!-- if visa doc -->
            <div v-if="missing_visa_indefinite || missing_visa_expiry" class="col-12">
              <div class="row">
                <div class="col-12">
                  <h4 class="red_color mt-2">Incomplete VISA information</h4>
                </div>
                <div class="col-12">
                  <div class="row">
                    <label class="col-7 cardLabel" style="line-height: 19px" for="visa_indefinite">Indefinite VISA?</label>
                    <div class="col-5 form-group">
                      <bootstrap-toggle v-model="file.visa_indefinite" id="visa_indefinite" name="visa_indefinite" :options="{ on: 'Yes', off: 'No' }"/>
                    </div>
                  </div>
                </div>
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="VISA Expiry Date" tag="div" class="col-12 form-group"
                                    v-if="!file.visa_indefinite">
                  <label class="form-label" for="visa_expiry">VISA Expiry Date Date</label>
                  <datepicker v-model="file.visa_expiry" id="visa_expiry" name="visa_expiry" :input-class="['date-input', 'requiredField', classes]"
                              :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                              @input="select_visa_expiry(file.visa_expiry, file)" :use-utc="true"></datepicker>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-12 form-group mt-3">
              <div class="float-right">
                <button type="submit" class="btn orcaBtn sm_btn" :disabled="saving">
                  <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Updating File Information ...</span>
                  <span v-else>Update File Information</span>
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12" v-if="showExpirationErrors()">
        <div class="alert alert-danger mt-3">
          <i class="fas fa-exclamation-triangle"></i> {{ showExpirationErrors() }}
        </div>
      </div>

      <div class="col-12" v-if="showExpirationNotices()">
        <div class="alert alert-info mt-3">
          <i class="fas fa-exclamation-circle"></i> {{ showExpirationNotices() }}
        </div>
      </div>
    </div>

    <div id="image_container">
      <img v-if="file_type === 'jpg' || file_type === 'JPG' || file_type === 'png' || file_type === 'PNG' || file_type === 'jpeg' || file_type === 'JPEG' || file_type === 'gif' ||
  file_type === 'GIF' || file_type === 'bmp' || file_type === 'BMP'" :src="file_path" style="max-width: 100%; display: block;" alt="uploaded file"/>

      <div v-if="file_type === 'pdf' || file_type === 'PDF' ">
        <object :data="file_path" type="application/pdf" style="width: 100%; min-height: 400px;">
          alt : <a :href="file_path">{{ file.file_name }}</a>
        </object>
      </div>
      <div v-if="file_type === 'doc' || file_type === 'DOC' || file_type === 'docx' || file_type === 'DOCX'">
        Download word document : <a :href="file_path">{{ file.file_name }}</a>
      </div>
      <div v-if="file_type === 'tif' || file_type === 'TIF' || file_type === 'tiff' || file_type === 'TIFF'">
        Download TIF/TIFF image file : <a :href="file_path">{{ file.file_name }}</a>
      </div>
    </div>

    <ValidationObserver ref="viewUpdateFileTypeForm" slim v-if="change_file_type">
      <form role="form" @submit.prevent="update_file_type()" class="row mt-3">
        <div class="col-12 mb-3">
          <div class="row">
            <div class="col-12">
              <h4 class="bp_color mt-2 mb-2">Change file type</h4>
              <p>Please select below the correct information to describe the uploaded file.</p>
            </div>
            <ValidationProvider rules="required" v-slot="{errors, classes}" name="New File Type" tag="div" class="form-group col-11 offset-1">
              <label class="form-label" for="new_file_type">File Type</label>
              <multiselect v-model="new_file_type.file_type" id="new_file_type" name="new_file_type" placeholder="" :allow-empty="false" :selectLabel="''" class="requiredField"
                           :options="file_types_original" label="file_type" :show-labels="false" @input="file_type_select(new_file_type.file_type, new_file_type)"></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>

            <!-- if pe insurance cert OR pi insurance cert OR if pe & pi insurance cert OR if passport OR if drivers licence OR if biometric ID -->
            <ValidationProvider rules="required" v-slot="{errors, classes}" name="Document Expiry Date" tag="div" class="col-6 offset-1 form-group"
                                v-if="new_file_type.file_type !== null && (new_file_type.file_type.id === 10 || new_file_type.file_type.id === 11 || new_file_type.file_type.id === 19 || new_file_type.file_type.id === 20 || new_file_type.file_type.id
                                 === 25 || new_file_type.file_type.id === 26 || new_file_type.file_type.id === 27 || new_file_type.file_type.id === 29 || new_file_type.file_type.id === 30 || new_file_type.file_type.id === 31)">
              <label class="form-label" for="change_document_expiry_date">Document Expiry Date</label>
              <datepicker v-model="new_file_type.document_expiry_date" id="change_document_expiry_date" name="change_document_expiry_date" :input-class="['date-input',
              'requiredField', classes]" :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                          @input="select_document_expiry(new_file_type.document_expiry_date, new_file_type)" :use-utc="true"></datepicker>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- if settlement status doc -->
            <div class="col-6 offset-1" v-if="new_file_type.file_type !== null && (new_file_type.file_type.id === 23)">
              <div class="row">
                <label class="col-7 cardLabel" style="line-height: 19px" for="change_settlement_indefinite">Indefinite Settlement?</label>
                <div class="col-5 form-group">
                  <bootstrap-toggle v-model="new_file_type.settlement_indefinite" id="change_settlement_indefinite" name="change_settlement_indefinite" :options="{ on: 'Yes',
                  off: 'No' }"/>
                </div>
              </div>
            </div>
            <ValidationProvider rules="required" v-slot="{errors, classes}" name="Settlement Expiry Date" tag="div" class="col-5 form-group"
                                v-if="new_file_type.file_type !== null && new_file_type.file_type.id === 23 && !new_file_type.settlement_indefinite">
              <label class="form-label" for="change_settlement_expiry">Settlement Expiry Date</label>
              <datepicker v-model="new_file_type.settlement_expiry" id="change_settlement_expiry" name="change_settlement_expiry" :input-class="['date-input',
              'requiredField', classes]" :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                          @input="select_settlement_expiry(new_file_type.settlement_expiry, new_file_type)" :use-utc="true"></datepicker>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- if visa doc -->
            <div class="col-6 offset-1" v-if="new_file_type.file_type !== null && (new_file_type.file_type.id === 24)">
              <div class="row">
                <label class="col-7 cardLabel" style="line-height: 19px" for="change_visa_indefinite">Indefinite Visa?</label>
                <div class="col-5 form-group">
                  <bootstrap-toggle v-model="new_file_type.visa_indefinite" id="change_visa_indefinite" name="change_visa_indefinite" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <ValidationProvider rules="required" v-slot="{errors, classes}" name="Visa Expiry Date" tag="div" class="col-5 form-group"
                                v-if="new_file_type.file_type !== null && new_file_type.file_type.id === 24 && !new_file_type.visa_indefinite">
              <label class="form-label" for="change_visa_expiry">VISA Expiry Date</label>
              <datepicker v-model="new_file_type.visa_expiry" id="change_visa_expiry" name="'change_visa_expiry" :input-class="['date-input', 'requiredField', classes]"
                          :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_visa_expiry(new_file_type.visa_expiry, new_file_type)"
                          :use-utc="true"></datepicker>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>

          </div>
        </div>
        <div class="col-6">
          <button class="btn orcaBtn grey_bg" @click.prevent="cancel_user_change_file_type">Cancel</button>
        </div>
        <div class="col-6">
          <button type="submit" class="btn orcaBtn" :disabled="saving">
            <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Updating ...</span>
            <span v-else>Update</span>
          </button>
        </div>
      </form>
    </ValidationObserver>

    <div class="row mt-2" v-if="notEmptyObject(file) && (!missing_document_expiry_date && !missing_settlement_indefinite && !missing_settlement_expiry &&
    !missing_visa_indefinite && !missing_visa_expiry) && !change_file_type">
      <div class="col-6">
        <button class="btn orcaBtn grey_bg" @click.prevent="user_change_file_type">Change file type</button>
      </div>
      <div class="col-6" v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager')) ||
    ($store.state.auth.me.id === file.file_logs?.log_by_id && this.can_delete)">
        <button class="btn orcaBtn danger float-left w-100" data-toggle="tooltip" title="Delete File" @click.prevent="deleteFile">Delete File</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import Datepicker from 'vuejs-datepicker';
import BootstrapToggle from 'vue-bootstrap-toggle';

export default {
  name: "view_file",
  components: {Multiselect, Datepicker, BootstrapToggle},
  data() {
    return {
      crm_url: process.env.MIX_APP_URL,

      file_types_original: [],
      file_types: [],

      file: {},
      file_type: null,
      file_path: '',
      // OLD ID type
      old_id_type: false,
      // if pe insurance cert OR pi insurance cert OR if pe & pi insurance cert OR if passport OR if drivers licence OR if biometric ID
      missing_document_expiry_date: false,
      // if settlement status doc
      missing_settlement_indefinite: false,
      missing_settlement_expiry: false,
      // if visa doc
      missing_visa_indefinite: false,
      missing_visa_expiry: false,

      change_file_type: false,
      new_file_type: {},

      saving: false,
      check_file: false,
      check_file_name: '',

      uk_ireland: ['United Kingdom (UK)', 'Wales', 'Scotland', 'Northern Ireland', 'England', 'Republic of Ireland'],
      eu: ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece',
        'Hungary', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'The Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden']
    }
  },
  mounted() {
    this.mount_template();
  },
  computed: {
    can_delete() {
      let file_created_add_10_minutes = this.$moment(this.file.created_at).utc().add(10, 'minutes');
      let can_delete = false;
      if (this.$moment().utc() < file_created_add_10_minutes) {
        can_delete = true;
      }
      return can_delete;
    },
    /**
     * check if can add another file for upload or not (file and type not missing from any others)
     */
    check_add_files() {
      if (this.$store.state.files.type === 'worker') {
        let temp_file_types = this.files.filter(f => {
          let test = true;
          if (f.file_type !== null) {
            // if pe insurance cert OR pi insurance cert OR if pe & pi insurance cert OR if passport OR if drivers licence OR if biometric ID type -> reset variables
            if (f.file_type.id === 10 || f.file_type.id === 11 || f.file_type.id === 19 || f.file_type.id === 20 || f.file_type.id === 25 || f.file_type.id === 26
                || f.file_type.id === 27 || f.file_type.id === 29 || f.file_type.id === 30 || f.file_type.id === 31) {
              if (f.document_expiry_date !== null && f.file !== null) {
                test = false;
              }
            }
            // if not settlement status type -> reset variables
            else if (f.file_type.id === 23) {
              if (f.settlement_expiry !== null && f.file !== null) {
                test = false;
              }
            }
            // if not visa status type -> reset variables
            else if (f.file_type.id === 24) {
              if (f.visa_expiry !== null && f.file !== null) {
                test = false;
              }
            }
            else {
              if (f.file !== null) {
                test = false;
              }
            }
          }
          if (test) {
            return f;
          }
        })
        return temp_file_types.length <= 0;
      }
    },
  },
  methods: {
    mount_template() {
      axios.get(this.crmApiPath + 'file/' + this.$store.state.files.id).then(file => {
        this.file = file.data;
        console.log(this.file)
        // OLD ID FILE
        if (file.data.file_type !== undefined && file.data.file_type !== null && (file.data.file_type.id === 6 || file.data.file_type.id === 7)) {
          if (file.data.document_expiry_date === null) {
            this.missing_document_expiry_date = true;
          }
          this.old_id_type = true;
        }

        // if document should have an expiry date and doesn't set data variable
        if (file.data.file_type !== undefined && file.data.file_type !== null && (file.data.file_type.id === 10 || file.data.file_type.id === 11 || file.data.file_type.id === 19 ||
            file.data.file_type.id === 20 || file.data.file_type.id === 25 || file.data.file_type.id === 26 || file.data.file_type.id === 27 || file.data.file_type.id === 29 ||
            file.data.file_type.id === 30 || file.data.file_type.id === 31 || file.data.file_type.id === 6 || file.data.file_type.id === 7)) {
          if (file.data.document_expiry_date === null) {
            this.missing_document_expiry_date = true;
          }
        }
        // settlement document - check if indefinite or not (check if it has an expiry date)
        if (file.data.file_type !== undefined && file.data.file_type !== null && (file.data.file_type.id === 23)) {
          if (file.data.settlement_indefinite === null) {
            this.missing_settlement_indefinite = true;
            this.file.settlement_indefinite = false;
          }
          else if (!file.data.settlement_indefinite) {
            if (file.data.settlement_expiry === null) {
              this.missing_settlement_expiry = true;
            }
          }

        }
        // visa document - check if indefinite or not (check if it has an expiry date)
        if (file.data.file_type !== undefined && file.data.file_type !== null && (file.data.file_type.id === 24)) {
          if (file.data.visa_indefinite === null) {
            this.missing_visa_indefinite = true;
            this.file.visa_indefinite = false;
          }
          else if (!file.data.visa_indefinite) {
            if (file.data.visa_expiry === null) {
              this.missing_visa_expiry = true;
            }
          }
        }

        this.file_type = /[^.]*$/.exec(file.data.file_name.replace(/ /g, "-"))[0];
        this.file_path = this.crm_url + '/' + file.data.file_path;
      })

      if (this.$store.state.files.type === 'company') {
        // filter file types for company
        this.file_types_original = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 1)
        this.file_types = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 1)

        // Exclude previously uploaded files
        if (this.$store.state.files.uploaded_files !== null) {
          for (let i = 0; i < this.$store.state.files.uploaded_files.length; i++) {
            // do not remove 'other_1' type from list of types : exclude all else
            if (this.$store.state.files.uploaded_files[i] !== 13) {
              this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 1 && ft.id !== this.$store.state.files.uploaded_files[i])
              this.file_types = this.file_types.filter(ft => ft.record_type_id === 1 && ft.id !== this.$store.state.files.uploaded_files[i])
            }
          }
        }
      }
      else if (this.$store.state.files.type === 'order_job') {
        // filter file types for order_job
        this.file_types_original = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 4)
        this.file_types = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 4)

        // Exclude previously uploaded files
        if (this.$store.state.files.uploaded_files !== null) {
          for (let i = 0; i < this.$store.state.files.uploaded_files.length; i++) {
            // do not remove 'other_1' type from list of types : exclude all else
            if (this.$store.state.files.uploaded_files[i] !== 13) {
              this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 4 && ft.id !== this.$store.state.files.uploaded_files[i])
              this.file_types = this.file_types.filter(ft => ft.record_type_id === 4 && ft.id !== this.$store.state.files.uploaded_files[i])
            }
          }
        }
      }
      else if (this.$store.state.files.type === 'worker') {
        // filter file types for worker (exclude old id_1 && id_2 && other_2 types)
        this.file_types_original = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 6 && ft.id !== 7 && ft.id !== 14)
        this.file_types = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 6 && ft.id !== 7 && ft.id !== 14)
        // UK nationality -> exclude : Biometric ID, settlement status, visa
        if (this.$store.state.files.nationality !== null && this.uk_ireland.includes(this.$store.state.files.nationality.country_name)) {
          this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 19 && ft.id !== 20 && ft.id !== 30 && ft.id !== 23 && ft.id !== 24)
          this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 19 && ft.id !== 20 && ft.id !== 30 && ft.id !== 23 && ft.id !== 24)
        }
        // EU nationality -> exclude : Biometric ID
        if (this.$store.state.files.nationality !== null && this.eu.includes(this.$store.state.files.nationality.country_name)) {
          this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 19 && ft.id !== 20 && ft.id !== 30)
          this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 19 && ft.id !== 20 && ft.id !== 30)
        }
        // International nationality -> exclude : settlement status
        if (this.$store.state.files.nationality !== null && !this.uk_ireland.includes(this.$store.state.files.nationality.country_name) &&
            !this.eu.includes(this.$store.state.files.nationality.country_name)) {
          this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 23)
          this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 23)
        }
        // if not limited company -> exclude : Professional Indemnity Insurance Certificate & Public Employers Liability Insurance Certificate
        if (this.$store.state.files.employment_type !== null && this.$store.state.files.employment_type.id !== 32) {
          this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 11 && ft.id !== 10 && ft.id !== 31)
          this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 11 && ft.id !== 10 && ft.id !== 31)
        }
        // depending on VAT registration remove option : if not -> exclude : VAT Certificate
        if (!this.$store.state.files.vat_registered) {
          this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== 12)
          this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 12)
        }
        // Exclude previously uploaded files
        if (this.$store.state.files.uploaded_files !== null) {
          for (let i = 0; i < this.$store.state.files.uploaded_files.length; i++) {
            // do not remove 'other_1' type from list of types : exclude all else
            if (this.$store.state.files.uploaded_files[i] !== 13) {
              this.file_types_original = this.file_types_original.filter(ft => ft.record_type_id === 3 && ft.id !== this.$store.state.files.uploaded_files[i])
              this.file_types = this.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== this.$store.state.files.uploaded_files[i])
            }
          }
        }
      }
    },

    showExpirationErrors() {

      // Indefinite documents cannot flag any expiration errors
      if (this.file.visa_indefinite === true || this.file.settlement_indefinite === true) {
        return '';
      }

      // Where an expiry is present AND has already expired flag as error
      if (this.file.visa_expiry !== null && this.$moment(this.file.visa_expiry).utc().isBefore()) {
        return 'Visa expired on: ' + this.$moment(this.file.visa_expiry).utc().format("DD/MM/YYYY");
      }

      // Where an settlement is present AND has already expired flag as error
      if (this.file.settlement_expiry !== null && this.$moment(this.file.settlement_expiry).utc().isBefore()) {
        return 'Settlement expired on: ' + this.$moment(this.file.settlement_expiry).utc().format("DD/MM/YYYY");
      }

      // Final fallback to the expiration date against the whole document
      if (this.file.document_expiry_date !== null && this.$moment(this.file.document_expiry_date).utc().isBefore()) {
        return 'Document expired on:' + this.$moment(this.file.document_expiry_date).utc().format("DD/MM/YYYY");
      }

      // Dates are missing this will be flagged up in a different warning
      return '';
    },
    showExpirationNotices() {

      // Indefinite documents do not carry an expiration
      if (this.file.visa_indefinite === true) {
        return 'Visa is Indefinite';
      }

      if (this.file.settlement_indefinite === true) {
        return 'Settlement is Indefinite';
      }

      // Where an expiry is present show it
      if (this.file.visa_expiry !== null && this.$moment(this.file.visa_expiry).utc().isAfter()) {
        return 'Visa will expire on: ' + this.$moment(this.file.visa_expiry).utc().format("DD/MM/YYYY");
      }

      if (this.file.settlement_expiry !== null && this.$moment(this.file.settlement_expiry).utc().isAfter()) {
        return 'Settlement will expire on: ' + this.$moment(this.file.settlement_expiry).utc().format("DD/MM/YYYY");
      }

      // Final fallback to the expiration date against the whole document
      if (this.file.document_expiry_date !== null && this.$moment(this.file.document_expiry_date).utc().isAfter()) {
        return 'Document will expire on:' + this.$moment(this.file.document_expiry_date).utc().format("DD/MM/YYYY");
      }

      // Dates are missing this will be flagged up in a different warning
      return '';
    },
    hideModal() {
      this.$refs.view_file_modal.hide();
      this.$store.commit('HIDE_FILE_MODAL');
    },
    update_file() {
      this.$refs.viewUpdateFileForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.viewUpdateFileForm);
        }
        else {
          this.file.log_by_type = 'App\\Models\\Users\\User';
          this.file.log_by_id = this.$store.state.auth.me.id;
          axios.patch(this.crmApiPath + 'file/' + this.file.id, this.file).then(res => {

            this.$store.commit('SHOW_VIEW_FILE_MODAL', {
              id: this.file.id,
              type: 'worker'
            });
            this.$nextTick(() => {
              this.$bus.$emit('file::reload', {type: 'worker', action: true});
              this.$bus.$emit('logs::reload', {type: 'worker', action: true});
              this.hideModal();
              // this.$store.state.files.view_modal = true;
              // this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_file_modal'));
            })
          })
        }
      });
    },
    /**
     * Filter file types as you add files - make sure that duplicate types can't be uploaded (other than other)
     */
    file_type_select(val, file) {
      this.$nextTick(() => {
        if (val !== null) {
          // if not pe insurance cert OR pi insurance cert OR if pe & pi insurance cert OR if passport OR if drivers licence OR if biometric ID type -> reset variables
          if (val.id !== 10 && val.id !== 11 && val.id !== 19 && val.id !== 20 && val.id !== 25 && val.id !== 26 && val.id !== 27 && val.id !== 29 && val.id !== 30 && val.id !==
              31) {
            file.document_expiry_date = null;
          }
          // if not settlement status type -> reset variables
          if (val.id !== 23) {
            file.settlement_indefinite = null;
            file.settlement_expiry = null;
          }
          // if not visa status type -> reset variables
          if (val.id !== 24) {
            file.visa_indefinite = null;
            file.visa_expiry = null;
          }
        }
        this.file_types = this.file_types_original;
        this.$nextTick(() => this.filter_file_types())
      })
    },
    /**
     * filter file types - selected types
     * ?? and existing uploaded types
     */
    filter_file_types() {
      this.file_types = this.file_types.filter(ft => this.file.file_type.id !== ft.id)
    },

    clearType() {
      this.file.file_type = null
    },

    /**
     * Date Format for datepicker
     * -------------------------------
     */
    dateFormat(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY");
    },
    /**
     * Format date picked
     * -------------------------------
     */
    select_document_expiry(selected_date, file) {
      if (selected_date !== null) {
        file.document_expiry_date = this.$moment(selected_date).utc().format('YYYY-MM-DD');
      }
    },
    select_settlement_expiry(selected_date, file) {
      if (selected_date !== null) {
        file.settlement_expiry = this.$moment(selected_date).utc().format('YYYY-MM-DD');
      }
    },

    select_visa_expiry(selected_date, file) {
      if (selected_date !== null) {
        file.visa_expiry = this.$moment(selected_date).format('YYYY-MM-DD');
      }
    },

    update_file_type() {
      this.$refs.viewUpdateFileTypeForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.viewUpdateFileTypeForm);
        }
        else {
          this.saving = true;
          this.new_file_type.log_by_type = 'App\\Models\\Users\\User';
          this.new_file_type.log_by_id = this.$store.state.auth.me.id;
          axios.patch(this.crmApiPath + 'file/' + this.new_file_type.id, this.new_file_type).then(res => {

            this.$store.commit('SHOW_VIEW_FILE_MODAL', {
              id: this.new_file_type.id,
              type: 'worker'
            });
            this.$nextTick(() => {
              this.$bus.$emit('file::reload', {type: 'worker', action: true});
              this.$bus.$emit('logs::reload', {type: 'worker', action: true});
              this.hideModal();
              // this.$store.state.files.view_modal = true;
              // this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_file_modal'));
            })
          })
        }
      });
    },

    user_change_file_type() {
      document.getElementById('image_container').style.width = '50%';

      this.new_file_type = Object.assign({}, this.file)
      
      if (this.$store.state.files.type === 'company') {
        this.file_types_original = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 1)
      }
      else if (this.$store.state.files.type === 'order_job') {
        this.file_types_original = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 4)
      }
      else if (this.$store.state.files.type === 'worker') {
        this.file_types_original = this.$store.state.crm_options.file_types.filter(ft => ft.record_type_id === 3 && ft.id !== 6 && ft.id !== 7 && ft.id !== 14)
      }
      
      this.$nextTick(() => { this.change_file_type = true})
    },

    cancel_user_change_file_type() {
      document.getElementById('image_container').style.width = '100%';
      this.change_file_type = false;
      this.new_file_type = {};
      this.mount_template();
    },

    deleteFile() {
      // confirm delete dialog
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Delete File</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to <strong>PERMANENTLY</strong> delete this file?' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-trash-alt"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              if (this.$store.state.files.type === 'company') {
                // add log values
                axios.delete(this.crmApiPath + 'file/' + this.file.id, {
                  params: {
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => {
                  this.$nextTick(() => {
                    this.$bus.$emit('file::reload', {type: 'company', action: true});
                    this.$bus.$emit('logs::reload', {type: 'company', action: true});
                    this.hideModal()
                  });
                })
              }
              else if (this.$store.state.files.type === 'order_job') {
                // add log values
                axios.delete(this.crmApiPath + 'file/' + this.file.id, {
                  params: {
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => {
                  this.$nextTick(() => {
                    this.$bus.$emit('file::reload', {type: 'order_job', action: true});
                    this.$bus.$emit('logs::reload', {type: 'order_job', action: true});
                    this.hideModal()
                  });
                })
              }
              else if (this.$store.state.files.type === 'worker') {
                // add log values
                axios.delete(this.crmApiPath + 'file/' + this.file.id, {
                  params: {
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => {
                  this.$nextTick(() => {
                    this.$bus.$emit('file::reload', {type: 'worker', action: true});
                    this.$bus.$emit('logs::reload', {type: 'worker', action: true});
                    this.hideModal()
                  });
                })
              }
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    }
  },
  watch: {
    'new_file_type.file_type'() {
      this.new_file_type.document_expiry_date = null;
      this.new_file_type.settlement_indefinite = null;
      this.new_file_type.settlement_expiry = null;
      this.new_file_type.visa_indefinite = null;
      this.new_file_type.visa_expiry = null;
    }
  }
}
</script>

<style lang="scss" scoped>
#image_container {
  width: 100%;
}
</style>
